/* eslint-disable react/no-unknown-property */
import React from 'react'
import * as THREE from 'three'

import { FOCUS_OVERLAY_CONTROLS } from '../constants'

interface FocusOverlayProps {
  active: boolean
}

const FULL_SCREEN_QUAD_SIZE = 2

const VERTEX_SHADER = `
  void main() {
    gl_Position = vec4(position.xy, 0.0, 1.0);
  }
`

const FRAGMENT_SHADER = `
  uniform vec3 overlayColor;
  uniform float overlayOpacity;

  void main() {
    gl_FragColor = vec4(overlayColor, overlayOpacity);
    #include <colorspace_fragment>
  }
`

function FocusOverlay({ active }: FocusOverlayProps) {
  const { color, opacity, overlayRenderOrder, stencilRef } =
    FOCUS_OVERLAY_CONTROLS

  const uniforms = React.useMemo(
    () => ({
      overlayColor: { value: new THREE.Color(color) },
      overlayOpacity: { value: opacity },
    }),
    [color, opacity]
  )

  return (
    <mesh
      visible={active}
      frustumCulled={false}
      renderOrder={overlayRenderOrder}
    >
      <planeGeometry args={[FULL_SCREEN_QUAD_SIZE, FULL_SCREEN_QUAD_SIZE]} />
      <shaderMaterial
        uniforms={uniforms}
        vertexShader={VERTEX_SHADER}
        fragmentShader={FRAGMENT_SHADER}
        transparent
        depthTest={false}
        depthWrite={false}
        stencilWrite
        stencilRef={stencilRef}
        stencilFunc={THREE.NotEqualStencilFunc}
      />
    </mesh>
  )
}

export default FocusOverlay
